import 'regenerator-runtime/runtime'

// TO DO move
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'mapbox-gl/src/css/mapbox-gl.css';

import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'
import IdleVue from 'idle-vue'
import FullLayout from './layouts/full-layout'
import NoOrgLayout from './layouts/no-org-layout'
import VueDraggableResizable from 'vue-draggable-resizable'
import VueObserveVisibility from 'vue-observe-visibility'

import moment from 'vue-moment'
import store from './store/store'
import router from './router'
import Toasted from 'vue-toasted';
import { getTokenData, clearTokenData } from './utils/token';

// HOTFIX: Clean up stale sessions (>30 days old)
// This prevents users with very old sessions from getting stuck in "limbo" state
// where they appear logged in but cannot use the app
console.log('🔍 [MAIN] Checking for stale sessions...');
const tokenData = getTokenData();

if (tokenData) {
  console.log('🔍 [MAIN] Token data found:', {
    hasAccessToken: !!tokenData.access_token,
    hasRefreshToken: !!tokenData.refresh_token,
    tokenType: tokenData.token_type,
    expiresIn: tokenData.expires_in,
    lastRefresh: tokenData.last_refresh,
    lastRefreshDate: tokenData.last_refresh ? new Date(tokenData.last_refresh).toISOString() : 'N/A'
  });
  
  if (tokenData.last_refresh) {
    const daysSinceRefresh = (Date.now() - tokenData.last_refresh) / (1000 * 60 * 60 * 24);
    console.log('🔍 [MAIN] Days since last refresh:', daysSinceRefresh.toFixed(2));
    
    if (daysSinceRefresh > 30) {
      console.warn('⚠️ [MAIN] STALE SESSION DETECTED - Cleaning up (>30 days old)');
      console.warn('⚠️ [MAIN] Last refresh was:', new Date(tokenData.last_refresh).toISOString());
      clearTokenData();
      localStorage.removeItem('my-app');
      localStorage.removeItem('userEmail');
      console.warn('⚠️ [MAIN] Auth data cleared - user will need to login');
      console.log('ℹ️ [MAIN] User preferences (orgId, siteId) preserved');
    } else {
      console.log('✅ [MAIN] Session is fresh (<30 days old)');
    }
  } else {
    console.warn('⚠️ [MAIN] Token data exists but no last_refresh timestamp');

    console.warn('⚠️ [MAIN] Invalid auth metadata (missing last_refresh) - clearing');
    clearTokenData();
    localStorage.removeItem('my-app');
    localStorage.removeItem('userEmail');
  }
} else {
  console.log('ℹ️ [MAIN] No token data found - user needs to login');
}

store.dispatch('readLogin');
Vue.use(Vuelidate)
Vue.use(moment)
Vue.use(Toasted)
Vue.use(VueObserveVisibility)

Vue.component('full-layout', FullLayout)
Vue.component('no-org-layout', NoOrgLayout)
Vue.component('vue-draggable-resizable', VueDraggableResizable)

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 24*60*60*1000, // 24 Hours
  startAtIdle: false
});

Vue.config.productionTip = false

new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
